<!--日五分钟数据-->
<template>
  <div>
    <el-table :data="dataList" height="795" border style="width: 100%;" v-loading="loading">
      <template slot="empty">
        <span class="noData">
          <img src="../../../assets/noData.png" alt="暂无数据">
          <span class="text">暂无数据</span>
        </span>
      </template>
      <el-table-column type="index" width="50" fixed>
      </el-table-column>
      <el-table-column prop="variablename" label="变量名" width="200" fixed>
      </el-table-column>
      <el-table-column prop="next" label="next" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.next" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0000" label="value0000" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0000" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0005" label="value0005" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0005" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0010" label="value0010" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0010" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0015" label="value0015" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0015" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0020" label="value0020" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0020" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0025" label="value0025" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0025" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0030" label="value0030" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0030" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0035" label="value0035" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0035" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0040" label="value0040" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0040" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0045" label="value0045" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0045" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0050" label="value0050" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0050" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0055" label="value0055" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0055" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0100" label="value0100" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0100" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0105" label="value0105" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0105" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0110" label="value0110" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0110" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0115" label="value0115" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0115" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0120" label="value0120" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0120" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0125" label="value0125" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0125" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0130" label="value0130" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0130" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0135" label="value0135" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0135" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0140" label="value0140" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0140" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0145" label="value0145" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0145" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0150" label="value0150" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0150" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0155" label="value0155" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0155" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0200" label="value0200" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0200" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0205" label="value0205" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0205" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0210" label="value0210" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0210" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0215" label="value0215" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0215" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0220" label="value0220" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0220" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0225" label="value0225" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0225" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0230" label="value0230" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0230" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0235" label="value0235" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0235" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0240" label="value0240" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0240" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0245" label="value0245" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0245" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0250" label="value0250" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0250" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0255" label="value0255" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0255" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0300" label="value0300" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0300" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0305" label="value0305" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0305" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0310" label="value0310" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0310" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0315" label="value0315" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0315" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0320" label="value0320" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0320" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0325" label="value0325" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0325" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0330" label="value0330" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0330" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0335" label="value0335" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0335" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0340" label="value0340" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0340" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0345" label="value0345" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0345" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0350" label="value0350" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0350" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0355" label="value0355" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0355" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0400" label="value0400" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0400" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0405" label="value0405" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0405" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0410" label="value0410" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0410" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0415" label="value0415" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0415" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0420" label="value0420" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0420" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0425" label="value0425" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0425" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0430" label="value0430" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0430" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0435" label="value0435" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0435" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0440" label="value0440" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0440" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0445" label="value0445" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0445" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0450" label="value0450" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0450" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0455" label="value0455" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0455" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0500" label="value0500" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0500" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0505" label="value0505" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0505" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0510" label="value0510" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0510" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0515" label="value0515" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0515" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0520" label="value0520" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0520" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0525" label="value0525" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0525" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0530" label="value0530" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0530" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0535" label="value0535" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0535" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0540" label="value0540" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0540" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0545" label="value0545" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0545" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0550" label="value0550" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0550" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0555" label="value0555" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0555" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0600" label="value0600" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0600" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0605" label="value0605" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0605" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0610" label="value0610" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0610" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0615" label="value0615" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0615" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0620" label="value0620" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0620" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0625" label="value0625" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0625" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0630" label="value0630" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0630" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0635" label="value0635" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0635" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0640" label="value0640" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0640" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0645" label="value0645" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0645" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0650" label="value0650" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0650" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0655" label="value0655" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0655" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0700" label="value0700" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0700" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0705" label="value0705" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0705" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0710" label="value0710" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0710" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0715" label="value0715" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0715" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0720" label="value0720" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0720" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0725" label="value0725" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0725" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0730" label="value0730" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0730" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0735" label="value0735" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0735" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0740" label="value0740" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0740" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0745" label="value0745" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0745" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0750" label="value0750" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0750" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0755" label="value0755" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0755" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0800" label="value0800" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0800" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0805" label="value0805" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0805" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0810" label="value0810" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0810" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0815" label="value0815" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0815" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0820" label="value0820" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0820" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0825" label="value0825" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0825" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0830" label="value0830" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0830" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0835" label="value0835" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0835" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0840" label="value0840" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0840" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0845" label="value0845" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0845" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0850" label="value0850" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0850" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0855" label="value0855" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0855" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0900" label="value0900" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0900" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0905" label="value0905" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0905" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0910" label="value0910" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0910" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0915" label="value0915" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0915" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0920" label="value0920" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0920" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0925" label="value0925" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0925" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0930" label="value0930" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0930" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0935" label="value0935" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0935" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0940" label="value0940" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0940" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0945" label="value0945" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0945" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0950" label="value0950" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0950" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0955" label="value0955" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0955" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1000" label="value1000" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1000" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1005" label="value1005" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1005" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1010" label="value1010" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1010" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1015" label="value1015" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1015" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1020" label="value1020" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1020" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1025" label="value1025" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1025" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1030" label="value1030" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1030" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1035" label="value1035" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1035" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1040" label="value1040" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1040" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1045" label="value1045" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1045" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1050" label="value1050" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1050" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1055" label="value1055" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1055" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1100" label="value1100" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1100" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1105" label="value1105" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1105" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1110" label="value1110" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1110" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1115" label="value1115" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1115" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1120" label="value1120" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1120" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1125" label="value1125" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1125" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1130" label="value1130" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1130" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1135" label="value1135" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1135" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1140" label="value1140" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1140" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1145" label="value1145" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1145" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1150" label="value1150" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1150" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1155" label="value1155" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1155" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1200" label="value1200" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1200" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1205" label="value1205" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1205" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1210" label="value1210" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1210" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1215" label="value1215" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1215" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1220" label="value1220" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1220" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1225" label="value1225" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1225" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1230" label="value1230" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1230" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1235" label="value1235" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1235" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1240" label="value1240" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1240" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1245" label="value1245" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1245" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1250" label="value1250" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1250" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1255" label="value1255" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1255" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1300" label="value1300" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1300" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1305" label="value1305" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1305" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1310" label="value1310" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1310" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1315" label="value1315" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1315" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1320" label="value1320" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1320" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1325" label="value1325" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1325" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1330" label="value1330" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1330" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1335" label="value1335" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1335" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1340" label="value1340" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1340" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1345" label="value1345" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1345" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1350" label="value1350" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1350" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1355" label="value1355" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1355" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1400" label="value1400" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1400" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1405" label="value1405" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1405" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1410" label="value1410" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1410" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1415" label="value1415" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1415" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1420" label="value1420" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1420" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1425" label="value1425" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1425" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1430" label="value1430" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1430" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1435" label="value1435" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1435" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1440" label="value1440" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1440" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1445" label="value1445" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1445" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1450" label="value1450" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1450" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1455" label="value1455" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1455" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1500" label="value1500" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1500" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1505" label="value1505" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1505" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1510" label="value1510" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1510" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1515" label="value1515" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1515" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1520" label="value1520" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1520" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1525" label="value1525" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1525" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1530" label="value1530" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1530" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1535" label="value1535" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1535" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1540" label="value1540" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1540" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1545" label="value1545" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1545" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1550" label="value1550" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1550" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1555" label="value1555" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1555" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1600" label="value1600" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1600" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1605" label="value1605" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1605" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1610" label="value1610" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1610" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1615" label="value1615" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1615" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1620" label="value1620" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1620" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1625" label="value1625" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1625" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1630" label="value1630" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1630" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1635" label="value1635" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1635" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1640" label="value1640" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1640" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1645" label="value1645" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1645" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1650" label="value1650" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1650" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1655" label="value1655" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1655" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1700" label="value1700" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1700" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1705" label="value1705" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1705" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1710" label="value1710" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1710" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1715" label="value1715" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1715" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1720" label="value1720" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1720" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1725" label="value1725" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1725" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1730" label="value1730" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1730" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1735" label="value1735" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1735" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1740" label="value1740" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1740" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1745" label="value1745" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1745" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1750" label="value1750" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1750" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1755" label="value1755" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1755" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1800" label="value1800" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1800" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1805" label="value1805" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1805" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1810" label="value1810" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1810" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1815" label="value1815" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1815" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1820" label="value1820" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1820" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1825" label="value1825" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1825" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1830" label="value1830" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1830" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1835" label="value1835" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1835" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1840" label="value1840" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1840" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1845" label="value1845" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1845" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1850" label="value1850" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1850" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1855" label="value1855" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1855" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1900" label="value1900" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1900" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1905" label="value1905" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1905" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1910" label="value1910" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1910" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1915" label="value1915" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1915" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1920" label="value1920" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1920" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1925" label="value1925" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1925" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1930" label="value1930" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1930" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1935" label="value1935" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1935" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1940" label="value1940" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1940" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1945" label="value1945" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1945" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1950" label="value1950" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1950" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1955" label="value1955" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1955" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2000" label="value2000" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2000" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2005" label="value2005" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2005" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2010" label="value2010" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2010" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2015" label="value2015" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2015" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2020" label="value2020" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2020" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2025" label="value2025" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2025" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2030" label="value2030" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2030" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2035" label="value2035" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2035" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2040" label="value2040" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2040" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2045" label="value2045" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2045" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2050" label="value2050" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2050" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2055" label="value2055" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2055" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2100" label="value2100" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2100" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2105" label="value2105" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2105" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2110" label="value2110" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2110" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2115" label="value2115" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2115" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2120" label="value2120" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2120" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2125" label="value2125" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2125" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2130" label="value2130" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2130" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2135" label="value2135" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2135" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2140" label="value2140" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2140" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2145" label="value2145" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2145" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2150" label="value2150" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2150" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2155" label="value2155" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2155" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2200" label="value2200" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2200" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2205" label="value2205" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2205" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2210" label="value2210" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2210" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2215" label="value2215" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2215" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2220" label="value2220" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2220" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2225" label="value2225" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2225" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2230" label="value2230" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2230" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2235" label="value2235" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2235" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2240" label="value2240" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2240" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2245" label="value2245" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2245" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2250" label="value2250" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2250" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2255" label="value2255" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2255" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2300" label="value2300" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2300" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2305" label="value2305" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2305" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2310" label="value2310" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2310" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2315" label="value2315" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2315" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2320" label="value2320" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2320" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2325" label="value2325" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2325" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2330" label="value2330" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2330" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2335" label="value2335" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2335" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2340" label="value2340" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2340" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2345" label="value2345" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2345" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2350" label="value2350" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2350" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2355" label="value2355" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2355" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="320" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="singleDetermine(scope.row)" plain>确定修改</el-button>
          <el-button type="primary" size="mini" @click="average(scope.row)">首尾平均</el-button>
          <el-button type="primary" size="mini" @click="increment(scope.row)">自动增量</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {
      dataList: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    created () {},
    mounted () {},
    destroyed () {},
    computed: {},
    watch: {},
    methods: {
      singleDetermine (data) {
        this.$emit("singleDetermine",data)
      },
      timeFormat (value) {
        let formatValue=0
        let hour=parseInt(value/60)
        let minute=value%60
        if(hour<10) {
          hour='0'+hour
        }
        if(minute<10) {
          minute='0'+minute
        }
        if(minute!=0) {
          formatValue=hour+(minute).toString()
        } else {
          formatValue=hour+'00'
        }
        return formatValue
      },
      average (row) {
        let first=row['value0000']
        let tail=row['next']
        if(tail!='-1.1111'&&!isempty(tail)&&first!='-1.1111'&&!isempty(first)) {
          let difference=((tail-first)/288).toFixed(3)
          let onValue=0
          for(let i=5;i<1440;i+=5) {
            let time=this.timeFormat(i)
            let oneTime=this.timeFormat(i-5)
            onValue=Number(row['value'+oneTime])
            if(onValue==-1.1111) {
              onValue=0
            }
            row['value'+time]=(onValue+Number(difference)).toFixed(3)

          }
          //将值找到再替换
        } else {
          this.$message.error("首值或者尾值不能为空")
        }
      },
      increment (row) {
        let first=row['value0000']
        let two=row['value0005']
        if(two!='-1.1111'&&!isempty(two)&&first!='-1.1111'&&!isempty(first)) {
          let difference=(two-first).toFixed(3)
          let onValue=0
          for(let i=5;i<1440;i+=5) {
            let time=this.timeFormat(i)
            let oneTime=this.timeFormat(i-5)
            onValue=Number(row['value'+oneTime])
            if(onValue==-1.1111) {
              onValue=0
            }
            row['value'+time]=(onValue+Number(difference)).toFixed(3)
          }
        } else {
          this.$message.error("第一值和第二值不能为空")
        }
      }
    }
  }
</script>

<style scoped>

</style>